module.exports = __webpack_public_path__ + "static/media/darkmode-search.1978ddca.svg";